// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.phone-numpad {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
}

.phone-display {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 6px;
  background: #F5F7F8;
  border: 1px solid #CFD8DC;
  border-radius: 6px;
  padding: 10px 12px;
  font-family: ui-monospace, "Menlo", monospace;
}

.phone-prefix {
  color: #78909C;
  font-size: 16px;
}

.phone-digits {
  font-size: 22px;
  letter-spacing: 4px;
  color: #263238;
}

.phone-digits .placeholder { color: #B0BEC5; }
.phone-digits .filled { color: #263238; font-weight: 600; }

.phone-help {
  font-size: 12px;
  color: #90A4AE;
  text-align: center;
}

.phone-error {
  font-size: 12px;
  color: #C62828;
  text-align: center;
}

.numpad-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
}

.numpad-key {
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
  height: 48px;
  font-size: 20px;
  font-weight: 600;
  background: #fff;
  border: 1px solid #CFD8DC;
  border-radius: 6px;
  cursor: pointer;
  transition: none;
}

.numpad-key:active:not(:disabled) { background: #ECEFF1; }
.numpad-key:disabled { opacity: 0.4; cursor: not-allowed; }

.numpad-clear, .numpad-backspace {
  background: #FAFAFA;
  color: #546E7A;
  font-size: 16px;
}

.phone-submit {
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  background: #455A64;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.phone-submit:disabled {
  background: #CFD8DC;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/PhoneNumpad.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA,6BAA6B,cAAc,EAAE;AAC7C,wBAAwB,cAAc,EAAE,gBAAgB,EAAE;;AAE1D;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,oCAAoC,mBAAmB,EAAE;AACzD,uBAAuB,YAAY,EAAE,mBAAmB,EAAE;;AAE1D;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".phone-numpad {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px;\n}\n\n.phone-display {\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  gap: 6px;\n  background: #F5F7F8;\n  border: 1px solid #CFD8DC;\n  border-radius: 6px;\n  padding: 10px 12px;\n  font-family: ui-monospace, \"Menlo\", monospace;\n}\n\n.phone-prefix {\n  color: #78909C;\n  font-size: 16px;\n}\n\n.phone-digits {\n  font-size: 22px;\n  letter-spacing: 4px;\n  color: #263238;\n}\n\n.phone-digits .placeholder { color: #B0BEC5; }\n.phone-digits .filled { color: #263238; font-weight: 600; }\n\n.phone-help {\n  font-size: 12px;\n  color: #90A4AE;\n  text-align: center;\n}\n\n.phone-error {\n  font-size: 12px;\n  color: #C62828;\n  text-align: center;\n}\n\n.numpad-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 6px;\n}\n\n.numpad-key {\n  touch-action: manipulation;\n  user-select: none;\n  -webkit-user-select: none;\n  height: 48px;\n  font-size: 20px;\n  font-weight: 600;\n  background: #fff;\n  border: 1px solid #CFD8DC;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: none;\n}\n\n.numpad-key:active:not(:disabled) { background: #ECEFF1; }\n.numpad-key:disabled { opacity: 0.4; cursor: not-allowed; }\n\n.numpad-clear, .numpad-backspace {\n  background: #FAFAFA;\n  color: #546E7A;\n  font-size: 16px;\n}\n\n.phone-submit {\n  height: 48px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #fff;\n  background: #455A64;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.phone-submit:disabled {\n  background: #CFD8DC;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
